<template lang="pug">

    div

        //- Varianten
        .five.fields
            number-field(label='Auflage #1' v-bind:isRequired='true' v-bind:min='1' v-model='printing1')
                error(:$v='$v.printing1' validator='required')
                    | Darf nicht leer sein. Bitte einen gültigen Auflage angeben
            number-field(label='Auflage #2' v-model='printing2' v-bind:min='1')
            number-field(label='Auflage #3' v-model='printing3' v-bind:min='1')
            number-field(label='Auflage #4' v-model='printing4' v-bind:min='1')
            number-field(label='Auflage #5' v-model='printing5' v-bind:min='1')

        //- Sorten
        sorts(v-model='sorts')

</template>

<script>
    import { required } from 'vuelidate/lib/validators'
    import Error from '../../form/FieldError.vue'
    import NumberField from '../../form/NumberField.vue'
    import Sorts from './general-information-form/Sorts.vue'

    export default {

        components: { Error, NumberField, Sorts },

        computed: {
            printing1: {
                get() { return this.value.printing1 },
                set(value) { this.updateValue('printing1', value) }
            },
            printing2: {
                get() { return this.value.printing2 },
                set(value) { this.updateValue('printing2', value) }
            },
            printing3: {
                get() { return this.value.printing3 },
                set(value) { this.updateValue('printing3', value) }
            },
            printing4: {
                get() { return this.value.printing4 },
                set(value) { this.updateValue('printing4', value) }
            },
            printing5: {
                get() { return this.value.printing5 },
                set(value) { this.updateValue('printing5', value) }
            },
            sorts: {
                get() { return this.value.sorts },
                set(value) { this.updateValue('sorts', value) }
            }
        },

        methods: {

            updateValue(target, value) {
                this.$emit('input', { ...this.value, [target]: value })
            }

        },

        props: {
            value: {
                type: Object,
                required: true
            }
        },

        validations: {
            printing1: { required }
        },

    }

</script>
